import { themeApis } from '../apis';

export const publishClientDraftTheme = async ({ shopifyThemeId, themeName }: { shopifyThemeId: string; themeName: string }) => {
  return themeApis.vedaApplication.userApi.theme.publishClientDraftTheme({ shopifyThemeId, themeName });
};
